"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _buttonDropdown = _interopRequireDefault(require("./button-dropdown.scss"));

var _button = _interopRequireWildcard(require("./button"));

var _icon = _interopRequireDefault(require("../icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ButtonDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ButtonDropdown, _Component);

  function ButtonDropdown() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ButtonDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ButtonDropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      menuOpen: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOutsideClick", function (e) {
      if (_this.dropdownMenu && !_this.dropdownMenu.contains(e.target)) {
        _this.setState({
          menuOpen: false
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDropdownButtonItemClick", function () {
      _this.setState({
        menuOpen: false
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(ButtonDropdown, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.props.loading || this.props.disabled;
    }
  }, {
    key: "handleDropdownButtonClick",
    value: function handleDropdownButtonClick() {
      var _this2 = this;

      !this.isDisabled() && this.setState(function (prevState) {
        return {
          menuOpen: !prevState.menuOpen
        };
      }, function () {
        return _this2.state.menuOpen && document.addEventListener('click', _this2.handleOutsideClick);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          buttonProps = (0, _objectWithoutProperties2["default"])(_this$props, ["children"]);

      var dropdownItems = _react["default"].Children.toArray(children).filter(function (child) {
        return child.type && child.type.displayName === 'ButtonDropdownItem';
      });

      var buttonText = _react["default"].Children.toArray(children).filter(function (child) {
        return !child.type;
      });

      var attributes = {};

      if (this.isDisabled()) {
        attributes.disabled = 'disabled';
      }

      return _react["default"].createElement("div", {
        className: _buttonDropdown["default"].buttonDropdownWrap,
        ref: function ref(element) {
          _this3.dropdownMenu = element;
        }
      }, _react["default"].createElement("div", {
        onClick: function onClick(e) {
          return _this3.handleDropdownButtonClick(e);
        }
      }, _react["default"].createElement(_button["default"], buttonProps, buttonText, _react["default"].createElement(_icon["default"], {
        size: "small",
        className: _buttonDropdown["default"].icon,
        type: "arrow-down"
      }))), _react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_buttonDropdown["default"].buttonDropdownMenu, (0, _defineProperty2["default"])({}, _buttonDropdown["default"].menuOpen, this.state.menuOpen)),
        onClick: this.handleDropdownButtonItemClick
      }, dropdownItems));
    }
  }]);
  return ButtonDropdown;
}(_react.Component);

exports["default"] = ButtonDropdown;
ButtonDropdown.propTypes = _objectSpread({}, _button.ButtonProps, {
  children: _propTypes["default"].node
});